import React, { useState } from 'react';
import { Box } from '@mui/material';
import MobileTopBar from './MobileTopBar';
import MobileBottomBar from './MobileBottomBar';
import MobileMenuDrawer from './MobileMenuDrawer';
import ProfileMenuPopup from '../ProfileMenuPopup';
import { useAuth } from '../../../context/AuthContext';
import { canAccessPlatformPreviewFeatures } from '../../../utils/platformPreviewAccess';
import {
  getSupplierBottomNav,
  getCoupleBottomNav,
  getSupplierMenuItems,
  getCoupleMenuItems,
} from './mobileNavConfig';

function MobileNavShell({
  children,
  isSupplier = false,
  userProfile,
  notifications = [],
  unreadCount = 0,
  unreadMessagesCount = 0,
  onMarkAsRead,
  onMarkAllAsRead,
  onDeleteAllNotifications,
  onDeleteNotification,
  onNotificationPageClick,
  onLogout,
  getPermissions,
}) {
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState(null);

  const handleProfileMenuOpen = (e) => setProfileMenuAnchorEl(e.currentTarget);
  const handleProfileMenuClose = () => setProfileMenuAnchorEl(null);

  let bottomNavItems = isSupplier ? getSupplierBottomNav() : getCoupleBottomNav();
  let menuItems = isSupplier ? getSupplierMenuItems() : getCoupleMenuItems();

  // Apps hub is platform-preview only (not generally released yet)
  if (isSupplier && !canAccessPlatformPreviewFeatures(user)) {
    menuItems = menuItems.filter((item) => item.path !== '/supplier/apps');
  }

  if (isSupplier && getPermissions) {
    const permissions = getPermissions();
    bottomNavItems = bottomNavItems.filter((item) => {
      if (!item.permissions || item.permissions.length === 0) return true;
      return item.permissions.some((p) => permissions.includes(p));
    });

    menuItems = menuItems
      .map((item) => {
        if (!item.children || item.children.length === 0) return item;
        const visibleChildren = item.children.filter((child) => {
          if (!child.permissions || child.permissions.length === 0) return true;
          return child.permissions.some((p) => permissions.includes(p));
        });
        return {
          ...item,
          children: visibleChildren
        };
      })
      .filter((item) => {
        if (item.children && item.children.length === 0) return false;
        if (!item.permissions || item.permissions.length === 0) return true;
        return item.permissions.some((p) => permissions.includes(p));
      });
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Box sx={{ position: 'sticky', top: 0, zIndex: 1200, bgcolor: 'background.paper' }}>
        <MobileTopBar
        userProfile={userProfile}
        onProfileMenuOpen={handleProfileMenuOpen}
        notifications={notifications}
        unreadCount={unreadCount}
        onMarkAsRead={onMarkAsRead}
        onMarkAllAsRead={onMarkAllAsRead}
        onDeleteAllNotifications={onDeleteAllNotifications}
        onDeleteNotification={onDeleteNotification}
        onNotificationPageClick={onNotificationPageClick}
      />
      </Box>

      <Box
        component="main"
        sx={{
          flex: 1,
          overflow: 'auto',
          pb: 8,
          pt: 0,
        }}
      >
        {children}
      </Box>

      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1100,
        }}
      >
        <MobileBottomBar
          items={bottomNavItems}
          onMenuClick={() => setMenuOpen(true)}
          unreadMessagesCount={isSupplier ? unreadMessagesCount : 0}
        />
      </Box>

      <MobileMenuDrawer
        open={menuOpen}
        onClose={() => setMenuOpen(false)}
        menuItems={menuItems}
        isSupplier={isSupplier}
      />

      <ProfileMenuPopup
        anchorEl={profileMenuAnchorEl}
        open={Boolean(profileMenuAnchorEl)}
        onClose={handleProfileMenuClose}
        userProfile={userProfile}
        onLogout={onLogout}
      />
    </Box>
  );
}

export default MobileNavShell;
